/* eslint-disable */
const worker = () => {
  function divideAndConquer(lookFor, data, len, order) {
    const half = Math.floor(len - 1 / 2)

    if (!data[half]) return -1
    if (data[half] === lookFor) return half

    if (order === 'A' && data[half] < lookFor) {
      return divideAndConquer(lookFor, data.slice(half, half * 2), half, order)
    } else if (order === 'D' && data[half] < lookFor) {
      return divideAndConquer(lookFor, data.slice(0, half), half, order)
    }

    if (order === 'A' && data[half] > lookFor) {
      return divideAndConquer(lookFor, data.slice(0, half), half, order)
    } else if (order === 'D' && data[half] > lookFor) {
      return divideAndConquer(lookFor, data.slice(half, half * 2), half, order)
    }

    return -1
  }

  self.addEventListener(
    'message',
    function (e) {
      const { len, dates, dateTimes, metrics, start, end } = e.data

      const from = divideAndConquer(start, dateTimes, dateTimes.length, 'D')
      const to = divideAndConquer(end, dateTimes, dateTimes.length, 'D')
      const data = {
        dates: dates.slice(from, to).reverse(),
        metrics: metrics.slice(from, to).reverse(),
      }

      self.postMessage(data)
    },
    false,
  )
}

let code = worker.toString()
code = code.substring(code.indexOf('{') + 1, code.lastIndexOf('}'))

const blob = new Blob([code], { type: 'application/javascript' })
const workerScript = URL.createObjectURL(blob)

export { workerScript }
